import React, { useEffect, ReactNode } from 'react';
import { useDispatch } from 'react-redux';
import { setIsBuiltInMode } from '../../slices/app-configs/app-configs.slice';
import { useStateSelector } from '../../store/selectors';
import { useBuiltInModalScroller } from '../../custom-hooks/useBuiltInModalScroller';

/**
 * Wrapper component that automatically sets built-in mode for routes
 * This should wrap any route that needs to be in built-in (iframe) mode
 */

const hideToastifyCss =
    '.Toastify, .Toastify__toast-container, .Toastify__toast { display: none !important; }';

interface BuiltInModeWrapperProps {
    children: ReactNode;
}

const BuiltInModeWrapper = ({ children }: BuiltInModeWrapperProps) => {
    useBuiltInModalScroller();
    const dispatch = useDispatch();
    const isBuiltInMode = useStateSelector(
        (state) => state.appConfigs.values.isBuiltInMode
    );
    useEffect(() => {
        dispatch(setIsBuiltInMode(true));
    }, []);

    useEffect(() => {
        if (isBuiltInMode) {
            const sendHeight = () => {
                const height = document.documentElement.offsetHeight;
                window.parent.postMessage({ type: 'setHeight', height }, '*');
            };
            const observer = new ResizeObserver(sendHeight);
            observer.observe(document.documentElement);
            observer.observe(document.body);
            sendHeight();

            return () => {
                observer.disconnect();
            };
        }
    }, [isBuiltInMode]);

    return (
        <>
            <style>{hideToastifyCss}</style>
            {children}
        </>
    );
};

export default BuiltInModeWrapper;
